import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	DatePicker,
	Table,
	Button,
	Modal,
	Image,
	Statistic,
	Row,
	Col,
	Select,
	notification,
	Input,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import {
	FileImageOutlined,
	CheckCircleOutlined,
	FilePdfOutlined,
	DeleteFilled,
	EditFilled,
} from "@ant-design/icons";
import { CSVLink } from "react-csv";
const { Text, Title } = Typography;
const { Search } = Input;

const jobStatusOptions = [
	{
		value: "Pouring",
		label: "Pouring",
	},
	{
		value: "A/R",
		label: "A/R",
	},
];

const WebLogisticsDashboard2 = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [loadingTable, setLoadingTable] = useState(false);
	const [loadingButton, setLoadingButton] = useState(false);
	const [date, setDate] = useState(dayjs());
	const [evidence, setEvidence] = useState(null);
	const [openEvidenceModal, setOpenEvidenceModal] = useState(false);
	const [clients, setClients] = useState([]);
	const [mines, setMines] = useState([]);
	const [dataExport, setDataExport] = useState([]);
	const [client, setClient] = useState("All");
	const [mine, setMine] = useState("All");
	const [ticket, setTicket] = useState("");
	const refDownload = useRef();
	const [data, setData] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Origin",
			dataIndex: "mine",
			key: "mine",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Truck",
			dataIndex: "truck",
			key: "truck",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Driver",
			dataIndex: "driver",
			key: "driver",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Quantity (ton)",
			dataIndex: "quantity",
			key: "quantity",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Ticket",
			dataIndex: "ticket",
			key: "ticket",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Material",
			dataIndex: "material",
			key: "material",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Destination",
			dataIndex: "client",
			key: "client",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Started Date",
			dataIndex: "startedDate",
			key: "startedDate",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Received Date",
			dataIndex: "receivedDate",
			key: "receivedDate",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Duration",
			dataIndex: "duration",
			key: "duration",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "",
			dataIndex: "actions",
			width: 100,
			render: (_, record) => {
				return (
					<Flex gap={"small"}>
						{!record.received && (
							<Button
								type="primary"
								style={{ backgroundColor: "green" }}
								icon={<CheckCircleOutlined twoToneColor={"white"} />}
								onClick={(e) => updateRecord(record.id, record.material)}
								loading={loadingButton}
								disabled={loadingButton}
							>
								End Trip
							</Button>
						)}

						{record.evidence && (
							<Button
								type="primary"
								icon={<FileImageOutlined twoToneColor={"white"} />}
								onClick={(e) => handleEvidenceOpen(record.evidence)}
								loading={loadingButton}
								disabled={loadingButton}
							>
								Evidence
							</Button>
						)}
						{record.receivedDate !== "-" && (
							<Button
								type="primary"
								style={{ backgroundColor: "red" }}
								icon={<FilePdfOutlined twoToneColor={"white"} />}
								onClick={(e) => history.push(`/logisticspdf/${record.id}`)}
								loading={loadingButton}
								disabled={loadingButton}
							>
								PDF
							</Button>
						)}
						{(localStorage.getItem("email") === "eliud@gmail.com" ||
							localStorage.getItem("email") === "ec@57concrete.com" ||
							localStorage.getItem("email") === "jip@57concrete.com" ||
							localStorage.getItem("email") === "ac@57concrete.com" ||
							localStorage.getItem("email") === "jl@57concrete.com" ||
							localStorage.getItem("email") === "vm@57concrete.com" ||
							localStorage.getItem("email") === "pc@57concrete.com" ||
							localStorage.getItem("email") === "gg@57xgroup.com" ||
							localStorage.getItem("email") === "scale@filegonia.com" ||
							localStorage.getItem("email") === "jc@57concrete.com" ||
							localStorage.getItem("email") === "reyesss22@icloud.com" ||
							localStorage.getItem("email") === "office@57logistics.com") && (
							<Button
								type="primary"
								style={{ backgroundColor: "red" }}
								icon={<DeleteFilled twoToneColor={"white"} />}
								onClick={(e) => deleteRecord(record.id)}
								loading={loadingButton}
								disabled={loadingButton}
							>
								Delete
							</Button>
						)}
						{(localStorage.getItem("email") === "eliud@gmail.com" ||
							localStorage.getItem("email") === "ec@57concrete.com" ||
							localStorage.getItem("email") === "vm@57concrete.com" ||
							localStorage.getItem("email") === "ac@57concrete.com" ||
							localStorage.getItem("email") === "jl@57concrete.com" ||
							localStorage.getItem("email") === "ar@57concrete.com" ||
							localStorage.getItem("email") === "cb@57concrete.com" ||
							localStorage.getItem("email") === "office@castlereadymix.com" ||
							localStorage.getItem("email") === "pc@57concrete.com" ||
							localStorage.getItem("email") === "gg@57xgroup.com" ||
							localStorage.getItem("email") === "scale@filegonia.com" ||
							localStorage.getItem("email") === "jc@57concrete.com" ||
							localStorage.getItem("email") === "reyesss22@icloud.com" ||
							localStorage.getItem("email") === "office@57logistics.com" ||
							(localStorage.getItem("email") === "jip@57concrete.com" &&
								record.client === "San Benito")) && (
							<Button
								type="primary"
								icon={<EditFilled twoToneColor={"white"} />}
								onClick={(e) => history.push(`/logisticstrip/${record.id}`)}
								loading={loadingButton}
								disabled={loadingButton}
							>
								Edit
							</Button>
						)}
					</Flex>
				);
			},
		},
	];

	const columnsCSV = [
		{
			label: "ID",
			key: "id",
		},
		{
			label: "Quantity",
			key: "quantity",
		},
		{
			label: "Material",
			key: "material",
		},
		{
			label: "Destination",
			key: "client",
		},
		{
			label: "Origin",
			key: "mine",
		},
		{
			label: "Status",
			key: "status",
		},
	];

	useEffect(() => {
		getValues();
	}, []);

	const getValues = async () => {
		await Promise.all([getClients(), getMines()]).then(() => {
			let dateString = `${date.year()}-${date.month() + 1}-${date.date()}`;
			getTripList(dateString, client, mine, ticket);
		});
	};

	const getClients = async () => {
		setLoading(true);
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const url = api + `/logistics/client/list/jap`;

		try {
			const { data } = await axios.get(url);
			let list = [
				{
					value: "All",
					label: "All",
				},
			];

			if (data.success) {
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setClients(list);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const getMines = async () => {
		setLoading(true);
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
		const url = api + `/logistics/mine/list/jap`;

		try {
			const { data } = await axios.get(url);
			let list = [
				{
					value: "All",
					label: "All",
				},
			];

			if (data.success) {
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setMines(list);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const getTripList = async (date, client, mine, ticket) => {
		setLoading(true);
		const url =
			api +
			`/logisticstrip/list?date=${date}&client=${client}&mine=${mine}&ticket=${ticket}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			let list = [];
			data.map((item, index) => {
				let duration = "0";
				if (item.startedDate && item.receivedDate) {
					var diffMs = new Date(item.receivedDate) - new Date(item.startedDate);
					var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
					var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
					duration = `${diffHrs} hours, ${diffMins} minutes`;
				}

				list.push({
					key: index,
					id: item._id,
					mine: item.mineId.name,
					material: item.materialId.name,
					quantity: item.quantity,
					ticket: item.ticket,
					client: item.clientId.name,
					driver: item.driver.name,
					truck: item.truck.number,
					evidence: item.evidence || null,
					startedDate: item.startedDate
						? `${dayjs(item.startedDate)
								.toDate()
								.toLocaleDateString()} - ${dayjs(item.startedDate)
								.toDate()
								.toLocaleTimeString([], { timeStyle: "short" })}`
						: "-",
					receivedDate: item.receivedDate
						? `${dayjs(item.receivedDate)
								.toDate()
								.toLocaleDateString()} - ${dayjs(item.receivedDate)
								.toDate()
								.toLocaleTimeString([], { timeStyle: "short" })}`
						: "-",
					duration: duration,
					received: item.received,
					jobStatus: item.jobStatus || "Pouring",
				});
			});

			let dupes = {};
			list.forEach((item, index) => {
				dupes[item.ticket] = dupes[item.ticket] || [];
				dupes[item.ticket].push(index);
			});

			Object.entries(dupes).forEach((item, index) => {
				if (item[1].length > 1) {
					item[1].map((val) => (list[val].duplicated = true));
				}
			});

			const cDate = dayjs(date);

			const formattedDate = `${cDate.get("M") + 1}${cDate.get(
				"date"
			)}${cDate.get("y")}`;

			const grouped = list.reduce((accum, currentObj) => {
				let material = "";
				switch (currentObj.material) {
					case "Sand":
						material = "S";
						break;
					case "Concrete Sand":
						material = "S";
						break;
					case "Gravel":
						material = "G";
						break;
					case '1" Gravel':
						material = "G";
						break;
					case "Pea Gravel":
						material = "PG";
						break;
					case "Caliche":
						material = "C";
						break;
					case "Select Fill":
						material = "SF";
						break;
					case "Construction Debris":
						material = "CD";
						break;
					case "Cyclone Sand":
						material = "CS";
						break;
					case "Crushed 3/4":
						material = "C34";
						break;
					case '1" Limestone':
						material = "L";
						break;
					default:
						break;
				}

				let client = "";
				switch (currentObj.client) {
					case "Mission":
						client = "M";
						break;
					case "San Benito":
						client = "SB";
						break;
					case "Laredo":
						client = "L";
						break;
					case "Brownsville":
						client = "B";
						break;
					case "Valley Wide":
						client = "VW";
						break;
					default:
						client = "";
						break;
				}

				let mine = "";
				switch (currentObj.mine) {
					case "Mile 4":
						mine = "M";
						break;
					case "Texan":
						mine = "SB";
						break;
					case "Rojo Limestone":
						mine = "RL";
						break;
					default:
						mine = "";
						break;
				}

				const id = `${formattedDate}-${material}-${client}-${mine}`;
				if (!accum[currentObj.material]) {
					accum[currentObj.material] = {
						ids: [],
						trips: [],
					};
				}

				if (!accum[currentObj.material].ids.find((i) => i.id === id)) {
					accum[currentObj.material].ids.push({
						id: id,
						quantity: 0,
						material: currentObj.material,
						client: currentObj.client,
						mine: currentObj.mine,
						status: currentObj.jobStatus || "Pouring",
					});
				}

				const indexOfId = accum[currentObj.material].ids.findIndex(
					(i) => i.id === id
				);

				accum[currentObj.material].ids[indexOfId].quantity +=
					currentObj.quantity;

				accum[currentObj.material].trips.push(currentObj);

				return accum;
			}, {});

			const mapped = Object.entries(grouped).map(([material, items]) => ({
				material,
				...items,
			}));

			const ids = [];

			mapped.map((item) => {
				ids.push(...item.ids);
			});

			setDataExport(ids);

			setData(mapped);

			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const updateRecord = async (id, material) => {
		setLoadingTable(true);
		setLoadingButton(true);
		const url = api + `/logisticstrip/update/jap/${id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			let body = {
				received: true,
				status: "Delivered",
			};
			const { data: serverData } = await axios.patch(url, body);

			let duration = "0";
			if (serverData.startedDate && serverData.receivedDate) {
				var diffMs =
					new Date(serverData.receivedDate) - new Date(serverData.startedDate);
				var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
				var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
				duration = `${diffHrs} hours, ${diffMins} minutes`;
			}

			const indexOfMaterial = data.findIndex((i) => i.material === material);
			const indexOfId = data[indexOfMaterial].trips.findIndex(
				(i) => i.id === id
			);
			data[indexOfMaterial].trips[indexOfId].received = true;
			data[indexOfMaterial].trips[indexOfId].duration = duration;
			data[indexOfMaterial].trips[indexOfId].receivedDate = `${dayjs(
				data.receivedDate
			)
				.toDate()
				.toLocaleDateString()} - ${dayjs(data.receivedDate)
				.toDate()
				.toLocaleTimeString([], { timeStyle: "short" })}`;
			setData(data);
			setLoadingTable(false);
			setLoadingButton(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const updateRecordJobStatus = async (id, status) => {
		const url = api + `/logisticstrip/update/jap/${id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			let body = {
				jobStatus: status,
			};
			await axios.patch(url, body);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const deleteRecord = async (id) => {
		setLoadingTable(true);
		const url = api + `/logisticstrip/delete/${id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.delete(url);
			let dateString = `${date.year()}-${date.month() + 1}-${date.date()}`;
			getTripList(dateString, client, mine, ticket);
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const onChangeJobStatus = async (value, material, client, mine) => {
		setLoadingTable(true);
		setLoadingButton(true);

		const trips = data.find((i) => i.material === material).trips;

		const filteredTrips = trips.filter(
			(i) => i.client === client && i.mine === mine
		);

		await Promise.all(
			filteredTrips.map((item) => updateRecordJobStatus(item.id, value))
		).then(() => {
			openNotification("success", "Success", `${material} Status Updated`);
			const indexOfMaterial = data.findIndex((i) => i.material === material);
			const indexOfId = data[indexOfMaterial].ids.findIndex(
				(i) => i.mine === mine && i.client === client
			);
			data[indexOfMaterial].ids[indexOfId].status = value;

			const ids = [];

			data.map((item) => {
				ids.push(...item.ids);
			});

			setDataExport(ids);

			setLoadingTable(false);
			setLoadingButton(false);
		});
	};

	const copyTickets = (type) => {
		let textContent = "";
		data
			.find((i) => i.material === type)
			.trips.map((i, index) => {
				if (index < data.find((i) => i.material === type).trips.length - 1) {
					textContent += i.ticket + ",";
				} else {
					textContent += i.ticket;
				}
			});
		navigator.clipboard.writeText(textContent);
	};

	const RenderTables = () => {
		return (
			<Flex gap="medium" justify="center" vertical>
				{data.map((item, index) => (
					<Table
						key={index}
						title={() => (
							<>
								<Title level={2}>{item.material} Orders</Title>
								<Button
									size="large"
									type="primary"
									danger
									onClick={() => copyTickets(item.material)}
								>
									Copy {item.material} Tickets
								</Button>
								{item.ids.map((itemId, indexId) => {
									return (
										<Row gutter={16} key={indexId}>
											<Col span={3}>
												<Flex vertical>
													<Text strong>ID</Text>
													<Text>{itemId.id}</Text>
												</Flex>
											</Col>
											<Col span={3}>
												<Flex vertical>
													<Text strong>Quantity</Text>
													<Statistic
														title=""
														value={itemId.quantity}
														precision={2}
														valueStyle={{ fontSize: 14 }}
													/>{" "}
												</Flex>
											</Col>
											<Col span={3}>
												<Flex vertical>
													<Text strong>Material</Text>
													<Text>{itemId.material}</Text>
												</Flex>
											</Col>
											<Col span={3}>
												<Flex vertical>
													<Text strong>Destination</Text>
													<Text>{itemId.client}</Text>
												</Flex>
											</Col>
											<Col span={3}>
												<Flex vertical>
													<Text strong>Origin</Text>
													<Text>{itemId.mine}</Text>
												</Flex>
											</Col>
											<Col span={3}>
												<Flex vertical>
													<Text strong>Status</Text>
													<Select
														options={jobStatusOptions}
														value={itemId.status}
														onChange={(value) =>
															onChangeJobStatus(
																value,
																itemId.material,
																itemId.client,
																itemId.mine
															)
														}
													/>
												</Flex>
											</Col>
											{indexId === 0 && (
												<Col span={3}>
													<Flex vertical>
														<Text strong>PDF</Text>
														<Button
															type="primary"
															icon={<FilePdfOutlined twoToneColor={"white"} />}
															onClick={(e) =>
																history.push(
																	`/logistics/pdf/${itemId.material}`,
																	{
																		date: date,
																		client: client,
																		mine: mine,
																	}
																)
															}
														>
															PDF {itemId.material}
														</Button>
													</Flex>
												</Col>
											)}
										</Row>
									);
								})}
							</>
						)}
						columns={columns}
						dataSource={item.trips}
						pagination={{
							defaultPageSize: 10,
							showSizeChanger: true,
							pageSizeOptions: ["10", "30", "50", "100"],
						}}
						loading={loadingTable}
						onRow={(record, index) => ({
							style: {
								background: record.duplicated
									? "#b9d3fa"
									: !record.evidence && record.received
									? "#fab9b9ff"
									: "white",
							},
						})}
					/>
				))}
			</Flex>
		);
	};

	const onChangeDate = (date) => {
		let dateString = `${date.year()}-${date.month() + 1}-${date.date()}`;
		getTripList(dateString, client, mine, ticket);
		setDate(date);
	};

	const handleEvidenceCancel = () => {
		setLoadingButton(false);
		setOpenEvidenceModal(false);
	};

	const handleEvidenceOpen = (evidence) => {
		setLoadingButton(true);
		setEvidence(evidence);
		setOpenEvidenceModal(true);
	};

	const RenderEvidence = () => {
		return (
			<Modal
				title="Evidence Image"
				open={openEvidenceModal}
				onCancel={handleEvidenceCancel}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
			>
				<Flex align="center" justify="center">
					<Image id="evidence" width={300} src={evidence} />
				</Flex>
			</Modal>
		);
	};

	const onChangeClient = (value) => {
		if (value) {
			let dateString = `${date.year()}-${date.month() + 1}-${date.date()}`;
			getTripList(dateString, value, mine, ticket);
			setClient(value);
		}
	};

	const onChangeMine = (value) => {
		if (value) {
			let dateString = `${date.year()}-${date.month() + 1}-${date.date()}`;
			getTripList(dateString, client, value, ticket);
			setMine(value);
		}
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const onSearch = (value) => {
		let dateString = `${date.year()}-${date.month() + 1}-${date.date()}`;
		getTripList(dateString, client, mine, value);
		setTicket(value);
	};

	const RenderDate = () => {
		return (
			<Flex gap={"middle"}>
				<DatePicker
					value={date}
					format={"MM/DD/YYYY"}
					onChange={onChangeDate}
					size="large"
					allowClear={false}
					style={{ width: 200 }}
					disabled={loading}
				/>
				<Select
					showSearch
					placeholder={`Select client`}
					optionFilterProp="children"
					size="large"
					onChange={onChangeClient}
					filterOption={filterOption}
					options={clients}
					disabled={loading}
					value={client}
					style={{
						width: "200px",
					}}
				/>
				<Select
					showSearch
					placeholder={`Select mine`}
					optionFilterProp="children"
					size="large"
					onChange={onChangeMine}
					filterOption={filterOption}
					options={mines}
					disabled={loading}
					value={mine}
					style={{
						width: "200px",
					}}
				/>
				<Search
					placeholder="Search by ticket"
					onSearch={onSearch}
					size="large"
					style={{
						width: "400px",
					}}
					enterButton
					allowClear
					disabled={loading}
					// value={ticket}
					// onChange={(e) => setTicket(e.target.value)}
				/>
			</Flex>
		);
	};

	const RenderButton = () => {
		return (
			<Row gutter={16}>
				{(localStorage.getItem("email") === "eliud@gmail.com" ||
					localStorage.getItem("email") === "ec@nextgsys.com" ||
					localStorage.getItem("email") === "pc@57concrete.com" ||
					localStorage.getItem("email") === "gg@57xgroup.com" ||
					localStorage.getItem("email") === "scale@filegonia.com" ||
					localStorage.getItem("email") === "jc@57concrete.com" ||
					localStorage.getItem("email") === "reyesss22@icloud.com" ||
					localStorage.getItem("email") === "office@57logistics.com") && (
					<Col span={24} xs={12} md={6} xl={4}>
						<Button
							size="large"
							type="primary"
							htmlType="button"
							style={{ width: "100%" }}
							loading={loading}
							onClick={() => history.push("/logisticstrip/new")}
						>
							New Trip
						</Button>
					</Col>
				)}
				<Col span={24} xs={12} md={6} xl={4}>
					<Button
						size="large"
						type="primary"
						htmlType="button"
						style={{ width: "100%" }}
						loading={loading}
						onClick={() => history.push("/reports/logistics/detailed")}
					>
						Detailed Report
					</Button>
				</Col>
				<Col span={24} xs={12} md={8} xl={6}>
					<Button
						type="primary"
						style={{ width: "100%" }}
						onClick={(e) => refDownload.current.link.click()}
						loading={loading}
						size="large"
					>
						Download Today Detailed Report
					</Button>
					<CSVLink
						data={dataExport}
						headers={columnsCSV}
						filename={"57concrete-logistics-detailed-today.csv"}
						hidden
						ref={refDownload}
					>
						Download report
					</CSVLink>
				</Col>
			</Row>
		);
	};

	return (
		<Layout title="Logistics Dashboard" description="Dashboard">
			<Flex vertical gap={"small"}>
				<RenderDate />
				<RenderButton />
				{loading ? <CustomSpinner /> : <RenderTables />}
			</Flex>
			<RenderEvidence />
			{contextHolder}
		</Layout>
	);
};

export default WebLogisticsDashboard2;
